<template>
  <div v-if="profile && profile.id">
    <v-layout align-center row :wrap="$vuetify.breakpoint.xsOnly" justify-center fill-height>
      <v-flex class="pt-4 text-xs-center">
        <AvatarUpload
          @success="$store.dispatch('candidate/profile/fetch', profile.id)"
          :src="profile.avatar || '/img/missing/avatars/original.png'"
          path="/candidate/profile/avatar"
          size="150"
          class="px-4"
          overlay
        />
      </v-flex>
      <v-flex class="pt-4 pr-4" :class="{ 'pa-4': $vuetify.breakpoint.xsOnly }" style="width: 80%">
        <FirstNames :value="profile.firstNames" />
        <LastName :value="profile.lastName" />
      </v-flex>
    </v-layout>
    <BiographyForm :profile="profile" />
  </div>
</template>

<script>
// Components
import AvatarUpload from '@/components/candidate/profile/edit/about/AvatarUpload'
import BiographyForm from '@/components/candidate/profile/edit/about/BiographyForm'
import FirstNames from '@/components/candidate/profile/edit/about/FirstNames'
import LastName from '@/components/candidate/profile/edit/about/LastName'

export default {
  components: { AvatarUpload, BiographyForm, FirstNames, LastName },

  props: { profile: { type: Object, required: true } },
}
</script>
